import settings from 'Cloud/settings';

// (web desktop): 18280 / 18281 / 18297
// (webview+touch): 18285 / 18286
const TARGET_SEGMENTS = new Set(['18280', '18281', '18297', '18285', '18286']);

const getSegments = (o_ss: unknown): string[] => {
    if (!o_ss) {
        return [];
    }

    if (Array.isArray(o_ss)) {
        return o_ss.map(String);
    }

    if (typeof o_ss === 'string') {
        return o_ss
            .split(/[;,]/g)
            .map((s) => s.trim())
            .filter(Boolean);
    }

    return [String(o_ss)];
};

/**
 * true, если пользователя нужно исключить из billing-personalization на лендинге promo/quota
 * из-за эксперимента по ценам 256ГБ
 *
 * */
export const skipBillingPersonalization = (): boolean => {
    const oss = settings?.params?.o_ss;
    const segments = getSegments(oss);
    const matched = segments.filter((s) => TARGET_SEGMENTS.has(s));

    return matched.length > 0;
};
